/** @jsxImportSource @emotion/react */
import React from "react";
import {css} from "@emotion/react";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";
import KpiDrawer from "js/admin/kpis/edit-kpis/common/kpi-drawer";
import KpiDrawerFallback from "js/admin/kpis/edit-kpis/common/kpi-drawer-fallback";

const CollapsedKpiBar = ({openedKpiIds, onOpen}) => {
  const {theme} = React.useContext(CustomThemeContext);
  return (
      <div
          css={collapsedBarStyle(theme)}
          onClick={onOpen}
      >
        <div css={collapsedBarIndicatorContainer(theme)}>
          <i className="bhi-edit-o" style={{fontSize: 24}} />
          {openedKpiIds && <span css={collapsedBarIndicator} data-test-id="metrics-open-count">{openedKpiIds.count()}</span>}
        </div>
      </div>
  );
};

const KpiSidebar = (props) => {
  const {
    open,
    onClose,
    openedKpiIds,
    focusedTabKpiId,
    idToWrappedKpi
  } = props;

  const focusedWrappedKpi = idToWrappedKpi.get(focusedTabKpiId);
  const kpi = focusedWrappedKpi?.get("kpi");

  if (!open) {
    return <CollapsedKpiBar openedKpiIds={openedKpiIds} onOpen={onClose} />;
  } else if (open && (!focusedTabKpiId || !kpi)) {
    return <KpiDrawerFallback {...props} />;
  } else {
    return <KpiDrawer {...props} />;
  }
};

const collapsedBarStyle = (theme) => css`
    position: absolute;
    right: -10px;
    top: 0;
    height: calc(100% + 10px);
    width: 60px;
    background-color: ${theme.palette.background.paper};
    display: flex;
    align-items: flex-start;
    justify-content: center;
    cursor: pointer;
    padding-top: 20px;
    z-index: 1;
    min-height: calc(100vh - 160px);
    box-shadow: -2px 0 3px rgba(0, 0, 0, 0.10);

    &:hover {
        box-shadow: -3px 0 5px rgba(0, 0, 0, 0.25);
    }
`;

const collapsedBarIndicatorContainer = (theme) => css`
    border-bottom: 1px solid ${theme.palette.border.light};
    position: relative;
    padding: 8px;
`;

const collapsedBarIndicator = (theme) => css`
    background: ${theme.palette.primary.main};
    height: 18px;
    width: 18px;
    display: flex;
    color: ${theme.palette.text.inverted};
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    position: absolute;
    top: -2px;
    right: -2px;
    font-size: 11px;
`;

export default KpiSidebar;